// @flow

import { connect } from 'react-redux';
import EditFlowScreenComponent from '../Components/EditFlowScreenComponent';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

const EditFlowScreenContainer = connect(mapStateToProps, mapDispatchToProps)(EditFlowScreenComponent);

export default EditFlowScreenContainer;



// WEBPACK FOOTER //
// ./src/Containers/EditFlowScreenContainer.js